import React, {useEffect} from 'react';
import styled from 'styled-components';
import {fontSize} from '../../mixins';
import {useTranslation} from 'react-i18next';
import UIButton from '../../UI/UIButton';
import {
    selectStripeNonce,
    sendUpsellPurchaseRequest
} from '../checkout/checkoutSlice';
import {useDispatch, useSelector} from 'react-redux';
import {selectToken, selectUserID} from '../signup/signupSlice';
import {sendAnalyticsEvents} from '../../analytics/common';
import {EVENTS} from '../../analytics/events';
import {selectEventsData} from '../events/eventsSlice';
import {useAnalyticsData} from '../checkout/helper';
const UPSELL_PLAN_SKU = 'fl-monthly-driver-sos-skovoroda';


const isArabic = navigator.language.startsWith('ar');
const textAlign = isArabic ? 'right' : 'left';

const blackTxt = `
 ${fontSize(18)};
 line-height: 22px;
 letter-spacing: -0.41px;
 color: #323232;
 font-weight: 300;
`;

const checkIco = (
    <svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M6.85049 12.0216C6.57485 12.0216 6.31119 11.9075 6.12244 11.7062L1.26575 6.52102C0.887242 6.11853 0.908215 5.48477 1.30969 5.10632C1.71217 4.72787 2.34435 4.74789 2.72086 5.15037L6.8405 9.54665L15.2376 0.333596C15.6111 -0.0758956 16.2423 -0.102928 16.6498 0.269519C17.0562 0.641965 17.0842 1.27573 16.7127 1.68321L7.58753 11.6952C7.40078 11.9015 7.13512 12.0196 6.85748 12.0216H6.85049Z" fill="#256EB0"/>
    </svg>
);

const StyledPopup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 3px solid #ECA5B3;
  border-radius: 10px;
  position: relative;
  padding: 47px 0 16px;
  
  div, p, ul {
     width: 100%;
  }
  
   &:before {
    content: attr(data-text);
    position: absolute;
    top: -26px;
    right: 25px;
    width: auto;
    color: #fff;
    padding: 14px 16px;
    ${fontSize(13)};
    line-height: 18px;
    font-weight: 600;
    mix-blend-mode: normal;
    background-color: #ECA5B3;
    box-shadow: 0 2px 16px rgba(50, 50, 50, 0.1);
    border-radius: 24px;
    text-align: center;
  }
`;

const StyledRow = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 0 18px;
    ${blackTxt};
    height: 22px;
    margin-bottom: 24px;
    position: relative;
    
    &:after {
        content: '';
        display: block;
        width: 100%;
        height: 1px;
        background: #F0F0F0;
        position: absolute;
        left: 0;
        bottom: -24px;        
    }
`;

const StyledOff = styled.span`
  color: #256EB0;
`;

const StyledList = styled.ul`
 list-style: none;
 padding: 0 18px;
 margin: 0 0 40px 0;
 ${blackTxt};
 line-height: 24px;
 color: #9C9C9C;
 
 li {
   padding: ${isArabic ? '16px 31px 0 0' : '16px 0 0 31px'};
   position: relative;
   text-align: ${textAlign};
   
   svg {
     position: absolute;
     ${textAlign}: 0;
     top: 20px;
   }
 }
`;

const StyledGreyLine = styled.p`
    padding: 0 18px;
    ${blackTxt};
    margin: 24px 0 0;
    text-align: ${textAlign};
`;


const UpsellPopup = ({closePopup}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const token = useSelector(selectToken);
    const stripeNonce = useSelector(selectStripeNonce);
    const analyticsParams = useAnalyticsData();
    const eventsData = useSelector(selectEventsData);
    const userID = useSelector(selectUserID);

    const onContinueClick = () => {
        sendAnalyticsEvents(EVENTS.upsellTapped, eventsData);
        dispatch(sendUpsellPurchaseRequest(stripeNonce, UPSELL_PLAN_SKU, token, analyticsParams, eventsData, userID));
        closePopup();
    };

    useEffect(() => {
        sendAnalyticsEvents(EVENTS.upsellView, eventsData)
    }, [eventsData]);

    return (
        <StyledPopup data-text={t('users_choice')}>
            <StyledRow>
                <span>{t('special_offer')}</span>
                <StyledOff>{t('15off')}</StyledOff>
            </StyledRow>

            <StyledGreyLine>{`$9.99/${t('month')}`}</StyledGreyLine>

            <StyledList>
                <li>
                    {checkIco}
                    {t('locate_loved_ones_in_a_crowd')}
                </li>
                <li>
                    {checkIco}
                    {t('share_your_flight_status')}
                </li>
                <li>
                    {checkIco}
                    {t('automated_sos_robotic_calls')}
                </li>
            </StyledList>
            <UIButton onClick={onContinueClick}>{t('continue')}</UIButton>
        </StyledPopup>
    );
};

export default UpsellPopup;